var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-main',{staticClass:"rh-medform"},[_c('form-contratcreate',{attrs:{"routes":_vm.contRoutes,"ismeddetail":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }